import { Component, OnInit } from '@angular/core';
import { PersonDetailsFacadeService } from '@qivos/qivoscloud-ion-components';
import {
  Address,
  Consent,
  Email,
  Person,
  QivosCloudService,
} from '@qivos/qivoscloud-ng-api';
import { environment } from 'src/environments/environment';
import {
  AuthByToken,
  Token,
  UpdatePersonData,
} from '../actions/ms-registration-form.actions';
import { MsRegistrationFormFacadeService } from '../services/ms-registration-form.facade.service';

@Component({
  selector: 'app-member-details-form',
  templateUrl: './member-details-form.component.html',
  styleUrls: ['./member-details-form.component.scss'],
})
export class MemberDetailsFormComponent implements OnInit {
  constructor(
    public PersonFacade: PersonDetailsFacadeService,
    public msRegistrationForm: MsRegistrationFormFacadeService,
    private qcService: QivosCloudService
  ) {}

  ngOnInit() {
    const token = this.getToken();
    this.msRegistrationForm.dispatch(Token({ token }));
    this.msRegistrationForm.dispatch(AuthByToken({ token }));
  }

  environment = environment;
  person = new Person();

  register() {
    if (
      this.PersonFacade.email.length > 0 &&
      this.PersonFacade.email !== this.msRegistrationForm.email
    ) {
      this.person.emailList?.push(
        new Email({ emailAddress: this.PersonFacade.email, isPrimary: true })
      );
    }

    if (this.PersonFacade.selectedRegionCode.length > 0) {
      this.person.addressList?.push(
        new Address({
          addressLine2: '',
          addressType: 'PRIMARY_PERSON_ADDRESS',
          town: this.PersonFacade.selectedTown,
          regionCode: this.PersonFacade.selectedRegionCode,
          countryCode: 'gr',
        })
      );
    }

    this.person.consentList?.push(
      new Consent({
        name: 'MS NEWS_AND_GENERAL_OFFERS SMS ',
        flag: this.PersonFacade.smsConsent,
      })
    );

    this.person.consentList?.push(
      new Consent({
        name: 'MS NEWS_AND_GENERAL_OFFERS EMAIL ',
        flag: this.PersonFacade.emailConsent,
      })
    );

    this.person.consentList?.push(
      new Consent({
        name: 'MS NEWS_AND_GENERAL_OFFERS VIBER ',
        flag: this.PersonFacade.viberConsent,
      })
    );

    if (this.PersonFacade.multiConsentsStatus === true) {
      this.person.consentList?.push(
        new Consent({
          name: 'MS NEWS_AND_GENERAL_OFFERS SMS ',
          flag: true,
        }),
        new Consent({
          name: 'MS NEWS_AND_GENERAL_OFFERS EMAIL ',
          flag: true,
        }),
        new Consent({
          name: 'MS NEWS_AND_GENERAL_OFFERS VIBER ',
          flag: true,
        })
      );
    }

    this.person.firstName = this.PersonFacade.firstName;
    this.person.lastName = this.PersonFacade.lastName;
    this.person.salutationCode = this.PersonFacade.gender.Value;
    this.person.gender = this.PersonFacade.gender.Value;
    this.person.dateOfBirth = this.PersonFacade.dateOfBirth;
    this.person.nameDayDay = this.PersonFacade.nameDateDay;
    this.person.nameDayMonth = this.PersonFacade.nameDateMonth;
    this.person.QCCode = this.msRegistrationForm.qcCode;
    this.person.registrationSource = 'LandingPage';

    this.msRegistrationForm.dispatch(UpdatePersonData({ person: this.person }));
  }

  getToken() {
    let url = window.location.href;
    let token = url.split('token=')[1];
    return token;
  }
}
